import Sidebar from './Sidebar';
import Navbar from './Navbar';
import './style.css';
//import Table from 'react-bootstrap/Table';
//import { Link } from "react-router-dom";

import React, { useEffect, useState } from 'react';
import axios from 'axios';


//const ViewLedgerTest = () => {
const ViewLedgerTest = ({ clientName }) => {

    const [purchaseTotal, setPurchaseTotal] = useState(0);
    const [salesTotal, setSalesTotal] = useState(0);
    const [debitTotal, setDebitTotal] = useState(0);
    const [creditTotal, setCreditTotal] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const purchaseResponse = await axios.get(`https://react-apis.dotlocalhost.com/ledgerShowNew.php?type=purchase&clientName=${clientName}`);
                const salesResponse = await axios.get(`https://react-apis.dotlocalhost.com/ledgerShowNew.php?type=sales&clientName=${clientName}`);
                const debitResponse = await axios.get(`https://react-apis.dotlocalhost.com/ledgerShowNew.php?type=debit&clientName=${clientName}`);
                const creditResponse = await axios.get(`https://react-apis.dotlocalhost.com/ledgerShowNew.php?type=credit&clientName=${clientName}`);

                setPurchaseTotal(purchaseResponse.data.totalBillSum);
                setSalesTotal(salesResponse.data.totalBillSum);
                setDebitTotal(debitResponse.data.debitSum);
                setCreditTotal(creditResponse.data.creditSum);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [clientName]);

    return (

        <div class="wrapper">
            <Sidebar />
            <div id="content">
                <Navbar />

                <div className='ineerBody'>

                    <div className='row'>
                        <div className='col-md-12 mb-5'>
                            <h3>Ledger Details Test</h3>
                        </div>
                    </div>

                    <div>
                        <h2>Ledger Information for {clientName}</h2>
                        <p>Total Bill (Purchase): {purchaseTotal}</p>
                        <p>Total Bill (Sales): {salesTotal}</p>
                        <p>Total Debit: {debitTotal}</p>
                        <p>Total Credit: {creditTotal}</p>
                    </div>

                </div>

            </div>

        </div>


    )
}

export default ViewLedgerTest;